module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-mainvijual-132da8afaec0d4f863e3bebd41dc9d34.jpg";